export const MAIN_CATEGORY_LABELS: Record<string, string> = {
  FIXED_COSTS: 'Frais Fixes',
  DAILY_LIFE: 'Vie Quotidienne',
  WORKS_EQUIPMENT: 'Travaux & Équipements',
  FUNDING_CALLS: 'Appels de fonds',
  RENTAL_HOUSING: 'Location & Hébergement',
  EVENTS_TOURISM: 'Événementiel & Tourisme',
  ESTATE_LANDS: 'Domaine & Terres',
  OPERATING: 'Exploitation',
  SUBSIDIES: 'Subventions & Aides',
  REIMBURSEMENTS: 'Refacturation & Remboursements',
};

export const SUB_CATEGORY_LABELS: Record<string, string> = {
  TAXES_AND_DUTIES: 'Impôts & Taxes',
  ENERGY_AND_WATER: 'Énergie & Eau',
  INSURANCE_AND_ADMIN: 'Assurances & Admin',
  CONTRACTS_AND_SUBSCRIPTIONS: 'Contrats & Abonnements',
  CONDO_FEES: 'Charges de Copropriété',
  GROCERIES: 'Courses & Alimentation',
  CLEANING_AND_LAUNDRY: 'Ménage & Linge',
  CONSUMABLES: 'Consommables',
  LEISURE: 'Loisirs',
  GARDEN: 'Jardin',
  MAJOR_WORKS: 'Gros Travaux',
  REPAIRS: 'Réparation & Maintenance',
  FURNITURE_DECOR: 'Ameublement & Décoration',
  EQUIPMENT: 'Équipements',
  REGULAR_TRANSFERS: 'Virements réguliers',
  EXCEPTIONAL_OPERATIONS: 'Opérations exceptionnelles',
  ONLINE_PLATFORMS: 'Plateformes en ligne',
  DIRECT_PRIVATE_CIRCLE: 'Direct & Cercle privé',
  PRIVATIZATION: 'Privatisation',
  PUBLIC_RECEPTION: 'Accueil public',
  LEASES_AND_RENTALS: 'Baux & Locations',
  DIRECT_OPERATION: 'Exploitation directe',
  ADDITIONAL_ACTIVITIES: 'Activités annexes',
  PUBLIC_FUNDS: 'Fonds publics',
  PRIVATE_FUNDS: 'Fonds privés',
  INTERNAL_TRIBE: 'Interne (Tribu)',
  EXTERNAL_THIRD_PARTY: 'Externe (Tiers)',
};

export const getCategoryLabel = (mainCategory: string, subCategory?: string | null): string => {
  if (subCategory) return SUB_CATEGORY_LABELS[subCategory] ?? subCategory;
  return MAIN_CATEGORY_LABELS[mainCategory] ?? mainCategory;
};

// Mirrors getMainCategory() from src/expenses/categorization.ts on the API.
const EXPENSE_TYPE_TO_MAIN_CATEGORY: Record<string, string> = {
  HOUSING_TAX: 'FIXED_COSTS',
  PROPERTY_TAX: 'FIXED_COSTS',
  WASTE_COLLECTION_TAX: 'FIXED_COSTS',
  OTHER_TAX: 'FIXED_COSTS',
  ELECTRICITY: 'FIXED_COSTS',
  WATER: 'FIXED_COSTS',
  GAS: 'FIXED_COSTS',
  HEATING_OIL: 'FIXED_COSTS',
  WOOD: 'FIXED_COSTS',
  WOOD_PELLETS: 'FIXED_COSTS',
  OTHER_ENERGY: 'FIXED_COSTS',
  HOME_INSURANCE: 'FIXED_COSTS',
  OTHER_INSURANCE: 'FIXED_COSTS',
  BANK_FEES: 'FIXED_COSTS',
  LEGAL_PROTECTION: 'FIXED_COSTS',
  MANAGEMENT_TRAVEL: 'FIXED_COSTS',
  OTHER_INSURANCE_AND_ADMIN: 'FIXED_COSTS',
  INTERNET_AND_PHONE: 'FIXED_COSTS',
  TV: 'FIXED_COSTS',
  ALARM: 'FIXED_COSTS',
  BOILER_MAINTENANCE: 'FIXED_COSTS',
  CHIMNEY_SWEEPING: 'FIXED_COSTS',
  GARDEN_MAINTENANCE: 'FIXED_COSTS',
  POOL_MAINTENANCE: 'FIXED_COSTS',
  TENNIS_MAINTENANCE: 'FIXED_COSTS',
  OTHER_CONTRACT: 'FIXED_COSTS',
  SYNDIC_FUND_CALLS: 'FIXED_COSTS',
  COMMON_AREAS_MAINTENANCE: 'FIXED_COSTS',
  OTHER_CONDO_CHARGES: 'FIXED_COSTS',
  SUPERMARKET: 'DAILY_LIFE',
  MARKET: 'DAILY_LIFE',
  CATERING: 'DAILY_LIFE',
  BEVERAGES: 'DAILY_LIFE',
  GROCERIES_CLEANING_PRODUCTS: 'DAILY_LIFE',
  HOUSE_FUND: 'DAILY_LIFE',
  OTHER_GROCERIES: 'DAILY_LIFE',
  HOUSEHOLD_CLEANING_PRODUCTS: 'DAILY_LIFE',
  DRY_CLEANING: 'DAILY_LIFE',
  LAUNDRY: 'DAILY_LIFE',
  CLEANING_LADY: 'DAILY_LIFE',
  OTHER_CLEANING_LAUNDRY: 'DAILY_LIFE',
  LIGHT_BULBS_BATTERIES: 'DAILY_LIFE',
  TOILET_PAPER: 'DAILY_LIFE',
  BBQ_CHARCOAL: 'DAILY_LIFE',
  LAWN_MOWER_FUEL: 'DAILY_LIFE',
  OTHER_CONSUMABLES: 'DAILY_LIFE',
  BOARD_GAMES: 'DAILY_LIFE',
  BIKES: 'DAILY_LIFE',
  RACKETS_AND_BALLS: 'DAILY_LIFE',
  OTHER_LEISURE: 'DAILY_LIFE',
  PLANTS: 'DAILY_LIFE',
  OCCASIONAL_GARDENER: 'DAILY_LIFE',
  FERTILIZERS_HERBICIDES: 'DAILY_LIFE',
  GARDEN_TOOLS_DAILY: 'DAILY_LIFE',
  OTHER_GARDEN: 'DAILY_LIFE',
  ROOFING: 'WORKS_EQUIPMENT',
  FACADE_RENOVATION: 'WORKS_EQUIPMENT',
  INSULATION: 'WORKS_EQUIPMENT',
  DOORS_WINDOWS: 'WORKS_EQUIPMENT',
  WOODWORK: 'WORKS_EQUIPMENT',
  MASONRY: 'WORKS_EQUIPMENT',
  PLUMBING_NETWORK: 'WORKS_EQUIPMENT',
  ELECTRICAL_NETWORK: 'WORKS_EQUIPMENT',
  HEATING_AND_AC: 'WORKS_EQUIPMENT',
  EARTHWORK: 'WORKS_EQUIPMENT',
  SANITATION: 'WORKS_EQUIPMENT',
  LANDSCAPING: 'WORKS_EQUIPMENT',
  POOL_LINER: 'WORKS_EQUIPMENT',
  POOL_FILTRATION: 'WORKS_EQUIPMENT',
  TENNIS_SURFACE: 'WORKS_EQUIPMENT',
  OTHER_MAJOR_WORKS: 'WORKS_EQUIPMENT',
  PLUMBER_REPAIR: 'WORKS_EQUIPMENT',
  ELECTRICIAN_REPAIR: 'WORKS_EQUIPMENT',
  LOCKSMITH: 'WORKS_EQUIPMENT',
  GARDENER_REPAIR: 'WORKS_EQUIPMENT',
  POOL_TECHNICIAN: 'WORKS_EQUIPMENT',
  MECHANIC: 'WORKS_EQUIPMENT',
  OTHER_REPAIR: 'WORKS_EQUIPMENT',
  SOFAS_BEDS: 'WORKS_EQUIPMENT',
  APPLIANCES: 'WORKS_EQUIPMENT',
  DISHWARE: 'WORKS_EQUIPMENT',
  DECORATION: 'WORKS_EQUIPMENT',
  LINENS: 'WORKS_EQUIPMENT',
  TV_HIFI: 'WORKS_EQUIPMENT',
  GARDEN_TOOLS_EQUIPMENT: 'WORKS_EQUIPMENT',
  HOUSE_TOOLS: 'WORKS_EQUIPMENT',
  MONTHLY_TRANSFER: 'FUNDING_CALLS',
  QUARTERLY_TRANSFER: 'FUNDING_CALLS',
  SEMI_ANNUAL_TRANSFER: 'FUNDING_CALLS',
  ANNUAL_TRANSFER: 'FUNDING_CALLS',
  PERIOD_END_ADJUSTMENT: 'FUNDING_CALLS',
  EXCEPTIONAL_WORK_CONTRIBUTION: 'FUNDING_CALLS',
  ACCOUNT_REPLENISHMENT: 'FUNDING_CALLS',
  OTHER_FUND_CALL: 'FUNDING_CALLS',
  AIRBNB_AGENCY: 'RENTAL_HOUSING',
  AIRBNB_DIRECT: 'RENTAL_HOUSING',
  BOOKING: 'RENTAL_HOUSING',
  GENS_DE_CONFIANCE: 'RENTAL_HOUSING',
  OTHER_ONLINE_RENTAL: 'RENTAL_HOUSING',
  BED_AND_BREAKFAST: 'RENTAL_HOUSING',
  FRIENDS_ACQUAINTANCES: 'RENTAL_HOUSING',
  INTERNAL_FAMILY_RENT: 'RENTAL_HOUSING',
  WEDDINGS_RECEPTIONS: 'EVENTS_TOURISM',
  SEMINAR_RENTAL: 'EVENTS_TOURISM',
  CINEMA_PHOTO_RENTAL: 'EVENTS_TOURISM',
  VISITS_TICKETING: 'EVENTS_TOURISM',
  SHOP_SOUVENIRS: 'EVENTS_TOURISM',
  HUNTING_LEASE: 'ESTATE_LANDS',
  FISHING_LEASE: 'ESTATE_LANDS',
  AGRICULTURAL_LEASE: 'ESTATE_LANDS',
  HAY_GRAIN_SALE: 'ESTATE_LANDS',
  WOOD_SALE: 'ESTATE_LANDS',
  WINTER_STORAGE: 'OPERATING',
  ELECTRICITY_RESALE: 'OPERATING',
  ANAH_RENOV_AID: 'SUBSIDIES',
  DRAC_SUBSIDY: 'SUBSIDIES',
  PATRONAGE_CROWDFUNDING: 'SUBSIDIES',
  TRIBE_FEES_SHARING: 'REIMBURSEMENTS',
  INSURANCE_CLAIM_REIMBURSEMENT: 'REIMBURSEMENTS',
  TAX_OVERPAYMENT: 'REIMBURSEMENTS',
  OTHER_REIMBURSEMENT: 'REIMBURSEMENTS',
};

export const getMainCategoryForType = (type: string): string =>
  EXPENSE_TYPE_TO_MAIN_CATEGORY[type] ?? 'FIXED_COSTS';
